// @flow
import React from 'react'
import type { Auction } from '../../services/auction/types'
import SmallText from '../texts/small-text'
import HeadingGamma from '../headings/heading-gamma'
import AuctionStateTag from '../tags/auction-state-tag'
import { formatDateShort } from '../../core/dateFormater'
import { Link } from 'react-router-dom'
import { AUCTION_STATE } from '../../services/auction/constants'

type CardBodyAuctionProps = {
  auction: Auction
}

const CardBodyAuction = (props: CardBodyAuctionProps) => {
  const { id, title, state, startTime, closeTime, location } = props.auction
  return (
    <div className='card-body'>
      <Link to={`/auctions/${id}`}>
        <HeadingGamma>{title}</HeadingGamma>
      </Link>
      {state !== AUCTION_STATE.PENDING && (
        <AuctionStateTag auctionState={state} />
      )}
      {state !== AUCTION_STATE.CLOSED && (
        <div>
          <SmallText center>{formatDateShort(closeTime)}</SmallText>
        </div>
      )}
      {state === AUCTION_STATE.PENDING && (
        <div>
          <SmallText highlight center>
            Bids open: {formatDateShort(startTime)}
          </SmallText>
        </div>
      )}
      <SmallText light>{location}</SmallText>
    </div>
  )
}

export default CardBodyAuction



// WEBPACK FOOTER //
// ./src/ui/cards/card-body-auction.js